import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import PreviewIcon from '@mui/icons-material/Edit';
import { Stack } from '@mui/material';
import DialogConfirmation from '../../components/DialogConfirmation';
import { useNavigate } from 'react-router-dom';

export default function RegistrationsTable({ registrations, deleteRegistration }) {
  const [rows, setRows] = React.useState([]);
  const [dialogState, setDialogState] = React.useState({});
  const navigate = useNavigate();

  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'first_name',
      headerName: 'First Name',
      flex: 1,
    },
    {
      field: 'last_name',
      headerName: 'Last Name',
      flex: 1,
    },
    {
      field: 'position',
      headerName: 'Position',
      flex: 1,
    },
    {
      field: 'email_address',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'phone',
      headerName: 'Phone',
      flex: 1,
    },
    {
      field: 'organization',
      headerName: 'Organization',
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
    },
    {
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => (
        <Stack direction='row' spacing={1}>
          <DeleteIcon
            onClick={() => setDialogState({ ...dialogState, delete: true, metadata: params?.row })}
            sx={{ cursor: 'pointer' }}
            fontSize='small'
            color='error'
          />
          <PreviewIcon onClick={() => navigate(`/portal/registrations/${params?.row?.uuid}`)} sx={{ cursor: 'pointer' }} fontSize='small' />
        </Stack>
      ),
    },
  ];

  const updateRows = () => {
    const _rows = [];
    registrations.forEach((registration, index) => {
      _rows.push({ ...registration, id: index + 1, uuid: registration.id });
    });

    setRows(_rows);
  };

  React.useEffect(() => {
    updateRows();
  }, [registrations]);
  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
      />
      <DialogConfirmation
        title='Konfirmasi'
        content='Apakah Anda yakin akan menghapus data ini'
        open={dialogState.delete}
        handleAgree={() => {
          setDialogState({ ...dialogState, delete: false });
          deleteRegistration(dialogState?.metadata?.uuid);
        }}
        handleClose={() => setDialogState({ ...dialogState, delete: false })}
        closeButtonText='Tidak'
        agreeButtonText='Ya'
      />
    </Box>
  );
}
